export default "__VITE_ASSET__DmRU3ni2__"